const dealerships = {
    getDealershipInfo: ({ cid }) => ({
        path: `/dealerships/${cid}`,
        method: 'GET'
    })
}

export default dealerships
